// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-header[data-v-590b7fec]{display:flex;justify-content:space-between;margin-bottom:15px;align-items:center}.tab-header h2[data-v-590b7fec]{margin:0}", ""]);
// Exports
module.exports = exports;
